import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { StyledActionButton } from '@/components/Buttons.tsx'
import { Stepper } from '@/components/Stepper.tsx'
import { Confirm } from '@/components/templates/Confirm.tsx'
import { FormStyled, FormSubmit } from '@/components/templates/Form.tsx'
import { ScrollableContent } from '@/components/templates/ScreenLayout.tsx'
import { ScreenWrapper } from '@/components/templates/ScreenWrapper.tsx'
import { Header1 } from '@/components/Text.tsx'
import { useTrackFormProgress } from '@/hooks/useTrackFormProgress.ts'
import {
  StepEnum,
  TOTAL_STEPS,
} from '@/screens/xpert/ManualBooking/constants.ts'
import { useAppointmentStore } from '@/store.ts'

import { XpertFormStep } from '../../../../utils/XpertFormSteps.ts'

const ConfirmBooking = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'confirmBooking',
  })
  const { trackFormInteraction } = useTrackFormProgress(
    XpertFormStep.ConfirmAllDetails,
  )
  const navigate = useNavigate()
  const { selectedSlot } = useAppointmentStore.getState()

  const handleGoBack = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      navigate(-1)
      trackFormInteraction({
        action: 'previous',
        formFieldName: 'back-to-previous',
      })
    },
    [navigate],
  )

  return (
    <ScreenWrapper>
      <FormStyled method="post">
        <Header1>{t('header')}</Header1>
        <Stepper total={TOTAL_STEPS} step={StepEnum.confirm} />
        {selectedSlot && (
          <ScrollableContent>
            <Confirm slot={selectedSlot} />
          </ScrollableContent>
        )}
        <FormSubmit>
          <StyledActionButton
            variant="Primary"
            type="submit"
            onClick={() => ({
              action: 'next',
              formFieldName: 'submit',
            })}
          >
            {t('actions.confirmBooking')}
          </StyledActionButton>
          <StyledActionButton
            variant="Secondary"
            onClick={handleGoBack}
            name="back-to-previous"
          >
            {t('actions.changeAppointment')}
          </StyledActionButton>
        </FormSubmit>
      </FormStyled>
    </ScreenWrapper>
  )
}

export { ConfirmBooking }
